export default __webpack_public_path__ + "static/media/ssrs.d77dc4b5.png";